import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getGenealogy(params) {
	return client.get("binary/genealogy", {
		params: params,
	});
}

function getGenealogyMobile(params) {
	return client.get("binary/genealogy/mobile", {
		params: params,
	});
}

function getMembership(params) {
	return client.get("binary/member/list-membership", {
		params: params,
	});
}

function getProspekList(params) {
	return client.get("binary/member/list-prospek", {
		params: params,
	});
}

function getSponsorisasi(params) {
	return client.get("binary/network/sponsorisasi", {
		params: params,
	});
}

function getDownline(params) {
	return client.get("binary/network/downline", {
		params: params,
	});
}

function getNetGrowth(params) {
	return client.get("binary/network/network-growth", {
		params: params,
	});
}

function getNetGrowthToday(params) {
	return client.get("binary/network/network-growth-today", {
		params: params,
	});
}

function checkCloneStatus(params) {
	return client.get("binary/genealogy/check-clone", {
		params: params,
	});
}

export default {
	getGenealogy,
	getGenealogyMobile,
	getMembership,
	getProspekList,
	getSponsorisasi,
	getDownline,
	getNetGrowth,
	getNetGrowthToday,
	checkCloneStatus
};